import React from 'react'
import './Footer.css'
function Footer() {
    return (
        <div className='Footer-content'>DISCLAIMER: The online calculator is developed based on theoretical and practical values obtained in various field experiments and cited in literatures. The solutions provided by the calculator are based on information provided by the user and the accuracy will depend upon the accuracy of the input. The authors may not be responsible for any variation in results.
        <div className='Footer-content'>ICAR-IISWC (VERSION 1.0)</div>
        </div>
    )
}

export default Footer